import { combineLatest, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

import { ChangeDetectionStrategy, Component, TemplateRef } from '@angular/core';

import { shareRef } from '../../../../operators/share-ref.operator';
import { StepWizardService } from '../../step-wizard.service';

interface WizardStep {
  id: TemplateRef<any>;
  title: string;
  active: boolean;
  completed: boolean;
}

@Component({
  standalone: false,
  selector: 'adspt-step-wizard-stepper',
  templateUrl: 'step-wizard-stepper.component.html',
  styleUrls: ['step-wizard-stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepWizardStepperComponent {
  readonly steps$: Observable<WizardStep[]> = combineLatest([this.sws.steps$, this.sws.activeIdx$]).pipe(
    map(([steps, activeIdx]) =>
      steps.map((step, index) => ({
        id: step.tr,
        title: step.title,
        active: index === activeIdx,
        completed: index < activeIdx,
      })),
    ),
    shareRef(),
  );

  readonly progressWidth$: Observable<string> = this.sws.steps$.pipe(
    distinctUntilChanged(),
    map((steps) => `calc(100% - ${100 / steps.length}%`),
  );

  readonly progressBarWidth$: Observable<number> = combineLatest([this.sws.steps$, this.sws.activeIdx$]).pipe(
    map(([steps, idx]) => (idx / (steps.length - 1)) * 100),
  );

  constructor(readonly sws: StepWizardService) {}

  trackByStep(_: number, step: WizardStep): TemplateRef<any> {
    return step.id;
  }
}
